<script setup>
import { onMounted, ref, defineProps } from 'vue';
import { useRouter } from 'vue-router';
const props = defineProps({
    title: {
        type: String,
        required: true,
    }
})
import i18n from "@/i18n"
import { getLangValue } from "@/utils/common"; //获取后端语言
const router = useRouter()
const isFullScreen = ref(false)
const userName = ref(sessionStorage.getItem("set_menu_list") && JSON.parse(sessionStorage.getItem("set_menu_list")).username)
const fullScreen = () => {
    //全屏切换
    if (!document.fullscreenElement && !isFullScreen.value) {
        // 进入全屏
        document.documentElement.requestFullscreen().then(() => {
            isFullScreen.value = true;
        });
    } else {
        // 退出全屏
        const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || (window.innerHeight === screen.height);
        if (fullscreenElement) {
            console.log(document.exitFullscreen);
            try {
                document.exitFullscreen().then(() => {
                    isFullScreen.value = false;
                });
            } catch {
                fullScreen();
            }

        }
    }
}

const goHome = () => {
    router.push({ path: '/homePage' })
}

const handlerJumpUser = () => {
    router.push({ path: "/user_info" });
}

const checkFullScreen = () => {
    //判断是否全屏
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || (window.innerHeight === screen.height);
    if (fullscreenElement) {
        isFullScreen.value = true;
        console.log("全屏模式");
    } else {
        isFullScreen.value = false;
        console.log("非全屏模式");
    }
}
const chineseClick = () => {
    const language = "ch";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const englishClick = () => {
    const language = "en";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
onMounted(() => {
    window.addEventListener("resize", checkFullScreen);
    window.addEventListener('keydown', function (e) {
        e = e || window.event
        if (e.key === 'F11' && !isFullScreen.value) {
            e.preventDefault()
            fullScreen();
        }
    })
})
</script>
<template>
    <div class="header d-flex justify-content-between p-3 align-items-center">
        <div class="title">{{ props.title }}</div>
        <div class="home d-flex  align-items-center cursor-pointer">
            <div class="d-flex align-items-center me-3">
                <i class="ri-user-2-fill me-2" style="font-size: 20px; color: rgb(10, 179, 156)"></i>
                <span @click="handlerJumpUser()" style=" cursor: pointer">{{ userName }}</span>
            </div>
            <div style="margin-right: 20px; ">
                <a href="javascript:;" @click="chineseClick()" style="color: #000000;">{{ getLangValue("base.chinese")
                    }}</a>
                <span style="padding: 0px 10px">|</span>
                <a href="javascript:;" @click="englishClick()" style="color: #000000;">{{ getLangValue("base.english")
                    }}</a>
            </div>
            <span @click="goHome">
                <i class="ri-home-8-line" style="font-size: 24px; color: #6D7080;" />
            </span>
            <span @click="fullScreen" style="font-size: 24px; color: #6D7080;">
                <!-- 图片问题 看起来比左边的高一点 -->
                <i class="bx bx-fullscreen ms-3" v-if="!isFullScreen" style="margin-top: 6px;"></i>
                <i class="bx bx-exit-fullscreen ms-3" v-else></i>
            </span>
        </div>
    </div>
</template>
<style>
.header {
    height: 60px;
    width: 100%;

    .title {
        font-size: 24px;
        font-weight: 700;
        /* color: white; */
        color: #212529;
    }

    .home {
        font-size: 14px;
        font-weight: 400;
        /* color: white; */
        color: #212529;
    }
}
</style>